module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C242"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C253"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/07_Preface#page_ix"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_1__The_Ironies_of_Affirmative_Ac#page_1"
    }
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" The Ironies of Affirmative Action")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Part_I__Understanding_Resistance#page_17"
    }
  }, [_c('strong', [_vm._v("Part I:")]), _vm._v(" Understanding Resistance to Affirmative Action")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_2__The_Appeal_of_Color_Blindness#page_19"
    }
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" The Appeal of Color-Blindness")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('a', {
    attrs: {
      "href": "#/html/11_3__American_Justice__Acceptable#page_36"
    }
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" American Justice, Acceptable Preference, and the Boundaries of Legitimate Policymaking")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_Part_II__Understanding_Support_f#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II:")]), _vm._v(" Understanding Support for Affirmative Action")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_4__Crisis_Management_through_Aff#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Crisis Management through Affirmative Action")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5__Administrative_Pragmatism_and#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" Administrative Pragmatism and the Affirmative Action Solution")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_6__Affirmative_Action_as_Traditi#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" Affirmative Action as Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_7__Creative_Destruction_in_the_N#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7.")]), _vm._v(" Creative Destruction in the Nixon Administration")])]), _vm._v(" "), _c('p', {
    staticClass: "C253"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_8__Conclusion__Culture__Politics#page_222",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8.")]), _vm._v(" Conclusion: Culture, Politics and Affirmative Action")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_Notes#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C255"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Index#page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f826b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_CONTENTS.vue
// module id = 69
// module chunks = 0